module.exports = __webpack_public_path__ + "static/forte_main_2-ea9baa912df57413c7c6cda762ada374.png";